// Bundle dependencies

// no polyfills here, they must be bundled in ns.wow Core

// Bundle plugin module (NSChart)

import Plugin from './Plugin';
import chartConfig from "./ChartConfig";


export default {

	version: () => {
		return NSContext.plugins.charts.version;
	}

};


// Initialize on document ready

document.addEventListener("DOMContentLoaded",
	function () {

		Plugin.init();

		if (NSContext.plugins.charts.enableKeyFigureComparison) {
			if (document.body.classList.contains('page-template-page-key-figures') || document.body.classList.contains('search-results') ) {
				Plugin.initKeyFigureComparison();
			}
		}

	});


